import {
  ListItem,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import React, { useEffect, useRef } from 'react';

const MayoReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return (
    <SessionReminderModal
      popupId="mayo-patient-reminders"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>Mayo Patient Reminders</ModalHeader>

        <ModalBody>
          <UnorderedList spacing={3} pl={2}>
            <ListItem>
              <strong>What is Mayo?</strong> A world-renowned academic medical
              center focused on integrated clinical care, education, and
              research for complex health conditions.
            </ListItem>
            <ListItem>
              You can leverage your MNT counseling experience, and should use
              Mayo Clinic&apos;s program resources as a reference.
            </ListItem>
            <ListItem>
              Partnerships are vital to the Berry Street ecosystem — revisit
              Mayo resources{' '}
              <a
                href="https://docs.google.com/document/d/1VatI5o5aMMwFmioImqHa22EsanT1vOKhPtK_-YTovG8/edit?tab=t.0#heading=h.gpndnyvhwvjd"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>
              .
            </ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalFooter>
          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={onClose}
              className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
            >
              Got it!
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default MayoReminderModal;
